<template>
    <main class="Policy">
        <div class="Policy__content">
            <div
                name="termly-embed"
                data-id="049b13e2-68a6-4505-8159-b681cbd952a5"
            ></div>
        </div>
    </main>
</template>

<script setup>
useHead({
    script: [
        {
            hid: 'termly-embed',
            src: 'https://app.termly.io/embed-policy.min.js',
            async: true,
            defer: true,
        },
    ],
})
</script>

<style lang="scss" scoped>
.Policy {
    @include grid;

    margin-top: var(--nav-offset);
    margin-bottom: 32px;
}

.Policy__content {
    grid-column: 2 / span 22;
    margin-left: -20px;
    max-width: 1000px;
}
</style>
